import { createRoot } from 'react-dom/client'
import './index.css'
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./sentry";
import Index from './pages/Index';
import Upsell from './pages/Upsell';
import Downsell from './pages/Downsell';
import DownsellAcceptance from './pages/DownsellAcceptance';
import DownsellDecline from './pages/DownsellDecline';
import UpsellAcceptance from './pages/UpsellAcceptance';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';

const queryClient = new QueryClient();

const Router = () => {
  const pathname = window.location.pathname;
  
  switch (pathname) {
    case '/upsell':
    case '/upsell.html':
      return <Upsell />;
    case '/downsell':
    case '/downsell.html':
      return <Downsell />;
    case '/downsell-success':
    case '/downsell-success.html':
      return <DownsellAcceptance />;
    case '/downsell-decline':
    case '/downsell-decline.html':
      return <DownsellDecline />;
    case '/upsell-success':
    case '/upsell-success.html':
      return <UpsellAcceptance />;
    case '/privacy':
    case '/privacy.html':
      return <Privacy />;
    case '/terms':
    case '/terms.html':
      return <Terms />;
    case '/disclaimer':
    case '/disclaimer.html':
      return <Disclaimer />;
    default:
      return <Index />;
  }
};

const MainApp = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Router />
    </TooltipProvider>
  </QueryClientProvider>
);

createRoot(document.getElementById("root")!).render(<MainApp />);
